module.exports = __webpack_public_path__ + "img/empty-white-box.56a424d1.png";